export default "__VITE_ASSET__BpdB$29T__"